import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointLg, sbkCoreBreakpointMd, sbkCoreBreakpointXl} from "@/tokens/variables";

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);
const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);

export const contentSliderStyles = css`
    ::slotted(swiper-slide) {
        height: auto;
    }

    :host {
        --slider-button__bg--focus: var(--_slider-button__bg--focus , var(--sbkSliderControlBgColorOnLightActive));
        --slider-button__color--focus: var(--_slider-button__color--focus , var(--sbkSliderControlFgColorOnDarkEnabled));
        --slider-button__border--focus: var(--_slider-button__border--focus , var(--sbkSliderControlBorderOnLightFocus));
        --slider-button__border-color--active: var(--_slider-button__border-color--active, var(--sbkSliderControlBorderOnLightActive));
        --slider-button__bg--active: var(--_slider-button__bg--active , var(--sbkSliderControlBgColorOnLightActive));
        --slider-button__color--active: var(--_slider-button__color--active, var(--sbkSliderControlFgColorOnDarkEnabled));

        --slider-button__bg--hover: var(--_slider-button__bg--hover , var(--sbkSliderControlBgColorOnLightHover));
        --slider-button__color--hover: var(--_slider-button__color--hover, var(--sbkSliderControlFgColorOnLightHover));
        --slider-button__border--hover: var(--_slider-button__border--hover, var(--sbkSliderControlBorderOnLightHover));
        
        --slider-button__color: var(--_slider-button__color, var(--sbkSliderControlFgColorOnLightEnabled));
        --slider-button__bg: var(--_slider-button__bg , var(--sbkSliderControlBgColorOnLightEnabled));
        --slider-button__border: var(--_slider-button__border , var(--sbkSliderControlBorderOnLightEnabled));
        --slider-pagination__width: 64px;
        --slider-pagination__color: var(--_slider-pagination__color , var(--sbkSliderControlFgColorOnLightEnabled));
    }

    .swiper {
        margin: 0 auto;
        max-width: calc(var(--sbkCoreContentAreaMaxWidth) + 2 * var(--sbkCoreGridXlMargin));
        padding-bottom: 20px;
        overflow: visible;
        @media all and (min-width: ${breakpointLg}) {
            overflow: hidden;
        }
    }

    .swiper-button-next,
    .swiper-button-prev {
        width: var(--sbkSliderControlSizingMaxHeightButton);
        height: var(--sbkSliderControlSizingMaxHeightButton);
        top: unset;
        bottom: 4px;
        font: var(--sbkRoundButtonLabel);
        border: var(--slider-button__border);
        border-radius: var(--sbkRoundButtonBorderRadiusBorderRadiusDefault);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: 2px solid transparent;
        outline-offset: var(--sbkRoundButtonBorderRadiusBorderGapFocus);
        background-color: var(--slider-button__bg);
        color: var(--slider-button__color);
        left: 50%;
        transform: translate(-50%);

        svg {
            display: none;
        }
    }

    .swiper-button-next {
        left: calc(50% + var(--sbkSliderControlSpacingGap) + var(--slider-pagination__width));
    }

    .swiper-button-prev {
        left: calc(50% - var(--sbkSliderControlSpacingGap) - var(--slider-pagination__width));
    }

    .swiper-button-next::after,
    .swiper-button-prev::after {
        content: ' ';
        display: block;
        width: var(--sbkSliderControlSizingMaxHeightButton);
        height: var(--sbkSliderControlSizingMaxHeightButton);
        mask-size: contain;
        inline-size: var(--sbkRoundButtonSizingMaxHeightMedium);
        background-color: var(--slider-button__color);
    }

    .swiper-button-next::after {
        mask: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.99938 19.2001C8.68938 19.2001 8.38937 19.0801 8.14937 18.8501C7.67937 18.3801 7.67937 17.6201 8.14937 17.1501L13.3094 11.9801L8.17938 6.85011C7.70938 6.38011 7.70938 5.62011 8.17938 5.15011C8.64938 4.68011 9.40938 4.68011 9.87938 5.15011L16.7094 11.9801L9.84938 18.8501C9.61938 19.0901 9.30938 19.2001 8.99938 19.2001Z'/%3E%3C/svg%3E%0A") no-repeat 50% 50%;
    }

    .swiper-button-prev::after {
        mask: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.9691 19.2001C14.6591 19.2001 14.3591 19.0801 14.1191 18.8501L7.28906 12.0201L14.1491 5.15011C14.6191 4.68011 15.3791 4.68011 15.8491 5.15011C16.3191 5.62011 16.3191 6.38011 15.8491 6.85011L10.6891 12.0201L15.8191 17.1501C16.2891 17.6201 16.2891 18.3801 15.8191 18.8501C15.5891 19.0801 15.2791 19.2001 14.9691 19.2001Z' fill='currentColor'/%3E%3C/svg%3E") no-repeat 50% 50%;
    }

    @media (hover: hover) and (pointer: fine) {
        .swiper-button-next:hover,
        .swiper-button-prev:hover {
            background-color: var(--slider-button__bg--hover);
            border: var(--slider-button__border--hover);
            color: var(--slider-button__color--hover);
            &:after{
                background-color: var(--slider-button__color--hover);
            }
        }
    }

    .swiper-button-next:focus-visible:not(:active),
    .swiper-button-prev:focus-visible:not(:active) {
        outline: var(--slider-button__border--focus);
        background-color: var(--slider-button__bg--focus);
        border: var(--slider-button__border-color--active);
        color: var(--slider-button__color--focus);
    }

    .swiper-button-next:focus-visible:not(:active)::after,
    .swiper-button-prev:focus-visible:not(:active)::after {
        background-color: var(--slider-button__color--focus);
    }

    .swiper-button-next--active, .swiper-button-next:active,
    .swiper-button-prev--active, .swiper-button-prev:active {
        background-color: var(--slider-button__bg--active);
        border: var(--slider-button__border-color--active);

        &:after{
            background-color: var(--slider-button__color--active);
        }
    }

    .swiper-pagination-custom {
        display: flex;
        gap: var(--sbkSliderControlSpacingGapText);
        font: var(--sbkSliderControlText);
        color: var(--slider-pagination__color);
        margin: var(--sbkStageSpacingViewportSmSliderControlMarginTop) auto 0 auto;
        position: relative;
        bottom: unset;
        top: unset;
        left: unset;
        width: fit-content;
    }

    @media all and (min-width: ${breakpointMd}) {
        .swiper-pagination-custom {
            margin-top: var(--sbkStageSpacingViewportMdSliderControlMarginTop);
        }
    }

    @media all and (min-width: ${breakpointLg}) {
        .swiper-pagination-custom {
            margin-top: var(--sbkStageSpacingViewportLgSliderControlMarginTop);
        }
    }

    @media all and (min-width: ${breakpointXl}) {
        .swiper-pagination-custom {
            margin-top: var(--sbkStageSpacingViewportXlSliderControlMarginTop);
        }
    }

    .swiper-button-lock {
        display: none;
    }

    .swiper-pagination-lock {
        display: none;
    }
`;

